<template>
    <!-- 物流详情窗口 -->
    <a-modal v-model="logistics" :width="900" title="查看物流信息" ok-text="取消寄件" :confirmLoading="confirmLoading" @ok="handleReject" @cancel="handleBack">
        <div class="logistics_address">
            <div class="logistics_address_icon">
              <img src="../../../../assets/location.png" alt="">
            </div>
            <div class="logistics_address_message">
              <div>
                  <span>{{this.userAddres.contactName}}</span><span style="padding-left:20px">{{this.userAddres.contactMobile}}</span>
              </div>
              <div>
                {{this.userAddres.provinceName}}{{this.userAddres.cityName}}{{this.userAddres.areaName}}{{ this.userAddres.address }}{{this.userAddres.addrDetail}}
              </div>
            </div>
        </div>
        <div class="sender">
          <div class="senderType" v-show="this.KDaddress.com">
            <div>
                {{ this.KDaddress.com == 'debangkuaidi' ? '德邦' : this.KDaddress.com == 'jd' ? '京东物流' : this.KDaddress.com == 'shunfeng' ? '顺丰速运' : this.KDaddress.com == 'huitongkuaidi' ? '百世汇通' :  this.KDaddress.com == 'tiantian' ? '天天快递' : this.KDaddress.com == 'zhongtong' ? '中通快递' :  this.KDaddress.com == 'yuantong' ? '圆通快递' : this.KDaddress.com == 'yunda' ? '韵达快递' : this.KDaddress.com == 'shentong' ? '申通快递' : this.KDaddress.com == 'zhaijisong' ? '宅急送' : this.KDaddress.com == 'youshuwuliu' ? '优速快递' : ''        }}
            </div>
            <div>
                 {{ this.KDaddress.nu }}
            </div>
            <div>
                <a @click="copyNum">复制</a>
            </div>
          </div>
          <div class="senderDetial">
            <div class="senderDetial-title">
              物流信息（{{this.KDaddress.state == '3'?'已签收':'运输中'  }}）：
            </div>
            <div class="senderDetial-detial">
                <div v-for="(item,idx) in this.KDaddress.data" :key="idx"><span>{{item.time}}</span><span>{{item.context}}</span></div>
                <!-- <div>2022-01-03 15:15:00，xx 快件已到达中转部..</div> -->
            </div>
          </div>
        </div>
        <a-modal v-model="isVisible" title="取消寄件" @cancel="cancelVisible" @ok="handleOk">
          <div style="text-align:center">确认取消当前快件？</div>
        </a-modal>
        
    </a-modal>
</template>
<script>
import {  cancelRecipeMail , getRecipeOrderAddr } from '@/api/modular/interhospital/recipetable/recipeManage'
export default {
    data(){
        return{
            confirmLoading : false,
            logistics : false,
            isVisible : false,
            parament : {},
            userAddres : [],
            record : {},
            KDaddress : {},
        }
    },
    methods:{
        // 初始化方法
        add (record) { 
            this.record = record;
            this.parament.recipeId = record.recipeId;
            this.logistics = true;
            this.userAddres = [];
            this.KDaddress = {};
            getRecipeOrderAddr({orderId:record.id}).then(res=>{
              console.log(res)
              if(res.code == '200'){
                this.userAddres = res.data;
                this.KDaddress = res.data.records.data;
              }else{
                this.userAddres = res.data;
                 this.$message.error(res.data.records.msg) 
              }
            })
        },
        // 点击提交物流信息
        handleReject(){
          this.logistics = false;
          this.isVisible = true;
        },
        //输入物流信息页面关闭按钮 
        handleBack(){
            this.logistics = false;
            this.visible = true;
        },
        copyNum(){
          let sendNum = this.KDaddress.nu;
          if(!sendNum){
            this.$message.info("暂无快递单号")
            return;
          };
          let copyInput = document.createElement('input');//创建input元素
          document.body.appendChild(copyInput);//向页面底部追加输入框
          copyInput.setAttribute('value', sendNum);//添加属性，将url赋值给input元素的value属性
          copyInput.select();//选择元素
          document.execCommand("Copy");//执行复制命令
          this.$message.success("复制成功！")
        },
        // 确认取消寄件
        handleOk(){
          this.confirmLoading = true;
          let params = {
            taskId : this.record.packageTaskId,
            orderId : this.record.packageOrderId,
            cancelMsg : '就想取消',
          }
          cancelRecipeMail(params).then(res=>{
            this.confirmLoading = false;
            if(res.code == 200){
              this.isVisible = false;
              this.$message.success('取消寄件成功')
              this.$parent.handleOk();
            }else{
              this.logistics = true;
              this.isVisible = false;
              this.$message.error(res.message)
            }
          })
        },
        cancelVisible(){
          this.isVisible = false;
          this.logistics = true;
        }
    }
}
</script>
<style lang="less" scoped>
.logistics_address{
  display: flex;
  height: 80px;
  padding: 10px;
  border-bottom: 1px solid #e8e8e8;
  .logistics_address_icon{
    &>img{
      width: 60px;
      height: 60px;
    }
    flex: 1;
    max-width: 60px;
    width: 60px;
    height: 60px;
    margin-right: 20px;
  }
  .logistics_address_message{
    flex: 1;
    &>div{
      height: 30px;
      line-height: 30px;
    }
  }
}
.sender{
  padding-top: 20px;
  .senderType{
    height: 40px;
    line-height: 40px;
    display: flex;
    width: 500px;
    &>div{
      flex: 3;
    }
    &>div:first-child{
      flex: 1;
    }
    &>div:nth-child(2){
      text-align: center;
    }
  }
  .senderDetial{
    .senderDetial-title{
      height: 40px;
      line-height: 40px;
      font-size: 15px;
      font-weight: bold;
    }
    .senderDetial-detial{
      height: 300px;
      border: 1px solid #e8e8e8;
      padding: 10px;
      overflow: hidden;
      overflow-y: scroll;
      &>div{
        margin-bottom: 10px;
        display: flex;
        &>span{
          flex: 4;
        }
        &>span:first-child{
          flex:1;
          max-width: 150px;
        }
      }
    }
  }
}
</style>